import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import GradingPage from './pages/GradingPage';
import SettingsPage from './pages/SettingsPage';
import { ToastProvider, ToastContainer } from './components/Toast';

function App() {
  return (
    <BrowserRouter>
      <ToastProvider>
        <div className="min-h-screen bg-gray-50">
          <Routes>
            <Route path="/" element={<Navigate to="/grade" replace />} />
            <Route path="/grade" element={<GradingPage />} />
            <Route path="/grade/:submissionId" element={<GradingPage />} />
            <Route path="/settings" element={<SettingsPage />} />
          </Routes>
        </div>
        <ToastContainer />
      </ToastProvider>
    </BrowserRouter>
  );
}

export default App;
